import AnyRecruiterLogin from "./AnyRecruiterLogin";

export default AnyRecruiterLogin;